import React, { Component } from 'react';
import { Button, Card, CardActions, CardHeader, Icon, IconButton } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

class Quotes extends Component {

    goToQuotes(e) {
        this.props.history.push("/quotes");
        e.stopPropagation();
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={this.props.className}>
                <Card className="card without-padding full-height" onClick={this.goToQuotes.bind(this)}>
                    <CardHeader title={"Mes devis"} titleTypographyProps={{ variant: "h6", color: 'primary' }}
                        avatar={
                            <Icon className={classes.iconStyle}>note_add</Icon>
                        }
                        action={
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />
                    <CardActions className={classes.cardActions} disableSpacing>
                        <Button variant="contained" size="small" color="secondary" onClick={this.goToQuotes.bind(this)}
                            startIcon={<Icon>arrow_forward</Icon>} className={classes.smallButton}>
                            Voir
                    </Button>
                    </CardActions>
                </Card>
            </div >
        );
    }
}

export default withRouter(Quotes);
